/*
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2019, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

import {h} from 'hyperapp';
import PanelItem from '../panel-item';

/**
 * Tray
 *
 * @desc Tray Panel Item
 */
export default class TrayPanelItem extends PanelItem {

  init() {
    if (this.inited) {
      return;
    }

    const actions = super.init({
      tray: this.core.make('osjs/tray').list()
    }, {
      setTray: tray => state => ({tray})
    });

    this.core.on('osjs/tray:update', list => actions.setTray(list));
  }

  render(state, actions) {
    const child = entry => { 
      if(entry && entry.icon){
        return h('div', {
        onclick: ev => entry.onclick(ev, entry),
        oncontextmenu: ev => entry.oncontextmenu(ev, entry),
        className: 'osjs-panel-item--clickable osjs-panel-item--icon'
      }, [
        h('div', {className : 'badge'}, [
          h('div', {
            className : entry.badge,
            innerHTML : entry.count})
        ]),
        h('img', {
          src: entry.icon,
          title: entry.title
        })]);
      }
    }
    return super.render('tray', state.tray.map(child));
  }

}

